import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardCallouts from 'common/components/card-callouts';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import TrendsChart from 'common/components/trends-chart';
import {getGroupsForPointTrends} from 'common/utils/chart-util';
import './index.scss';

export default class PointTrendsCard extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool.isRequired,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    disableConfig: false,
    report: {},
  };

  getGutters(isSingleUnit) {
    return {
      bottom: 18,
      left: 30,
      right: isSingleUnit ? 0 : 30,
      top: 18,
    };
  }

  isSingleUnit(unitsOrCurrencies) {
    const ids = new Set(
      unitsOrCurrencies.filter((x) => x).map((obj) => obj && obj.id),
    );
    return ids.size === 1;
  }

  render() {
    const {report} = this.props;

    const units = report.comparison.map((obj) => obj.unit);
    const currencies = report.comparison.map((obj) => obj.currency);
    const isSingleUnit = this.isSingleUnit([...units, ...currencies]);
    const gutters = this.getGutters(isSingleUnit);

    const groups = getGroupsForPointTrends(report, isSingleUnit);

    return (
      <Card className={'PointTrendsCard'} loading={false}>
        {(this.props.connectDragSource || ((x) => x))(
          <div>
            <CardHeader
              disableConfig={this.props.disableConfig}
              priorityWarnings={report.priorityWarnings}
              reportId={report.id}
              subtitle={report.meta.period.displayName}
              title={report.name || ''}
              warnings={report.warnings}
            />
          </div>,
        )}
        <CardContent>
          <TrendsChart groups={groups} gutters={gutters} />
          <CardCallouts meta={this.props.report.meta} />
        </CardContent>
      </Card>
    );
  }
}
